import Cookies from 'js-cookie'
/**
 * Summary: Helper
 * Description: common methods added at Helper utility
 * @author Pawan Gupta
 */
const Helper = (function () {
  /**
  * Description: get Object By Single Key from Object Array
  * @param {Array} _arrayObj
  * @param {string} key
  * @param {string || numeric} id
  * @param {Boolean} compareNumber
  * @return {Object}
  */
  const getObjectByKeySearch = (_arrayObj, keys, value) => {
    const data = _arrayObj.filter((item) => {
      return item[keys].toString().toUpperCase().includes(value.toString().toUpperCase())
    })
    if (data.length > 0) {
      return data
    } else {
      return false
    }
  }

  /**
    * Description: get Object By Multiple Key from Object Array
    * @param {Array} _arrayObj
    * @param {Array} keys
    * @param {string || numeric} id
    * @param {Boolean} compareNumber
    * @return {Object}
    */
  function getArrayObjectByMultipleKeySearch (_arrayObj, keys, value) {
    const data = _arrayObj.filter((item) => {
      return item[keys[0]].toUpperCase().includes(value.toUpperCase()) || item[keys[1]].toUpperCase().includes(value.toUpperCase()) ||
                item[keys[2]].toUpperCase().includes(value.toUpperCase()) || item[keys[3]].toUpperCase().includes(value.toUpperCase())
    })
    if (data.length > 0) {
      return data
    } else {
      return false
    }
  }

  /**
    * Description: get querystring value
    * @param {Array} keys
    * @return {String}
    */
  function getKey (key) {
    let value = ''
    const urlParams = new URLSearchParams(window.location.search)
    value = urlParams.get(key)
    if (!value) {
      if (key == 'session') {
        key = 'SID'
      }
      value = Cookies.get(key) ? Cookies.get(key) : ''
    }
    return value
  }
  /** 使用Cookies获取cookie */
  function getCookie (key) {
    if (!key) return ''
    return Cookies.get(key) ? Cookies.get(key) : ''
  }

  // 防抖函数
  function debounce (fun, delay = 250) {
    let timer = null
    return function (...args) {
      if (timer) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        fun.apply(this, args)
      }, delay)
    }
  }

  function localTeamInfo (key, value) {
    const session = getKey('SID')
    let store
    try {
      store = JSON.parse(localStorage.getItem('BILLING_TEAM_INFO')) || {}
    } catch (error) {
      store = {}
    }
    if (store.session != session) store = {}
    if (value) {
      store.session = session
      store[key] = value
      localStorage.setItem('BILLING_TEAM_INFO', JSON.stringify(store))
    } else {
      return store[key]
    }
  }

  function timestampToDate (timestamp, formatStr = 'YYYY/MM/DD HH:mm:ss', useUTC = false) {
    if (!timestamp) {
      return '---'
    }

    const date = new Date(Number(timestamp))
    const year = useUTC ? date.getUTCFullYear() : date.getFullYear()
    const month = useUTC ? date.getUTCMonth() + 1 : date.getMonth() + 1
    const day = useUTC ? date.getUTCDate() : date.getDate()
    const hour = useUTC ? date.getUTCHours() : date.getHours()
    const minute = useUTC ? date.getUTCMinutes() : date.getMinutes()
    const second = useUTC ? date.getUTCSeconds() : date.getSeconds()

    return formatStr.replace(/YYYY/g, year)
      .replace(/MM/g, ('0' + month).slice(-2))
      .replace(/M/g, month)
      .replace(/DD/g, ('0' + day).slice(-2))
      .replace(/D/g, day)
      .replace(/HH/g, ('0' + hour).slice(-2))
      .replace(/H/g, hour)
      .replace(/mm/g, ('0' + minute).slice(-2))
      .replace(/m/g, minute)
      .replace(/ss/g, ('0' + second).slice(-2))
      .replace(/s/g, second)
  }

  function getEnv () {
    const envObj = {
      billingprod1: 'bp1',
      billingprod2: 'bp2',
      billingprod3: 'bp3',
      billingd1: 'bill1',
      billingd2: 'bill2',
      billingd3: 'bill3',
      billingd4: 'bill4',
      billingd5: 'bill5',
      billingd6: 'bill6',
      billingd7: 'bill7'
    }
    let env = ''
    Object.keys(envObj).forEach(key => {
      if (Cookies.get(key)) {
        env = key
      }
    })
    return env
  }
  return {
    getObjectByKeySearch,
    getArrayObjectByMultipleKeySearch,
    getKey,
    debounce,
    localTeamInfo,
    getCookie,
    timestampToDate,
    getEnv
  }
})()

export default Helper
